<template>
    <Breadcrumbs main="SALES" mains="Point Of Sales" title="POS" />
    <div class="container-fluid default-dashboard">
    </div>
</template>

<script lang="ts" setup>

</script>